import { render, staticRenderFns } from "./TipoLocalArmazenamentoForm.vue?vue&type=template&id=455c6d5a"
import script from "./TipoLocalArmazenamentoForm.vue?vue&type=script&lang=js"
export * from "./TipoLocalArmazenamentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports